// src/Pages/AboutUs.js
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../Styles/AboutUs.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

function AboutUs() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
      mirror: true,
    });
  }, []);

  return (
    <main className="about-us-container">
      {/* Navbar */}
      <Navbar />

      {/* =========================
          HERO SECTION (NEW)
      ========================== */}
      <section className="hero-about-section" data-aos="fade-in">
        <div className="hero-about-content">
          <h1>About Us</h1>
          <p>
            Welcome to <strong>RoboFication LLC</strong>, where we are
            transforming safety-critical systems engineering with the power of
            AI, Systems Engineering, and Formal Methods. Scroll down to learn
            more about our vision, our founder, and how we’re shaping the
            future.
          </p>
        </div>
      </section>

      {/* =========================
          SECTION 1
      ========================== */}
      <section className="about-section" data-aos="fade-up">
        <div className="text-column">
          <h2>Driving Innovation in Safety-Critical Industries</h2>
          <p>
            Our mission is to accelerate development, improve safety, and
            empower industries to meet rigorous standards while staying ahead in
            a rapidly evolving technological landscape.
            <br />
            <br />
            We specialize in automating safety analysis, generating technical
            requirements, and leveraging cutting-edge technologies like
            Generative AI, Automated Formal Methods, and Trusted Autonomous
            Systems to deliver robust, reliable, and adaptive tools. By
            streamlining traditional engineering workflows, we help industries
            innovate faster, reduce costs, and ensure seamless compliance.
          </p>
        </div>
        <div className="image-column">
          <img
            src="about_images/aboutusinnovation.jpg"
            alt="Safety-Critical Industries"
          />
        </div>
      </section>

      {/* =========================
          SECTION 2
      ========================== */}
      <section className="about-section" data-aos="fade-up">
        <div className="image-column">
          <img src="about_images/aboutusfounder.jpg" alt="Our Founder" />
        </div>
        <div className="text-column">
          <h2>Our Founder</h2>
          <p>
            <strong>Dr. Md Tawhid Bin Waez</strong>, founder of RoboFication
            LLC, brings over a decade of expertise in
            <strong>
              {" "}
              formal methods, autonomous systems development, and
              safety-critical software engineering.
            </strong>{" "}
            His vision for RoboFication stems from his extensive experience
            automating complex engineering processes.
            <br />
            <br />
            As the <strong>
              principal technical expert and project lead
            </strong>{" "}
            at Ford Motor Company (2014–2023), Dr. Waez directed multi-year
            R&amp;D initiatives across North America and Europe, collaborating
            with top universities like MIT, the University of Michigan, and
            leading global tech firms. He led 14+ high-profile projects,
            advancing autonomous vehicle technology and software reliability.
            <br />
            <br />
            He holds a <strong>PhD in Computer Science</strong> from Queen’s
            University in Canada and has authored around{" "}
            <strong>20 peer-reviewed publications,</strong> including
            co-patents, journal and conference papers. He also earned a
            certification in
            <strong> Architecture and Systems Engineering</strong> from{" "}
            <strong>MIT xPRO</strong>, further cementing his expertise in
            managing complex certification projects.
          </p>
        </div>
      </section>

      {/* =========================
          SECTION 3
      ========================== */}
      <section className="about-section" data-aos="fade-up">
        <div className="text-column">
          <h2>Our Vision</h2>
          <p>
            At RoboFication, we are dedicated to transforming safety-critical
            systems engineering by eliminating inefficiencies, automating
            complex processes, and empowering teams to deliver innovative
            solutions faster. Our tools are built to address the most pressing
            challenges in the industry, enabling organizations to meet rigorous
            safety standards while driving innovation and efficiency.
            <br />
            <br />
            Together, we’re creating smarter, more reliable, and cost-effective
            systems that empower engineers, architects, and organizations to
            thrive in safety-critical industries.
          </p>
        </div>
        <div className="image-column">
          <img src="about_images/aboutusvision.jpg" alt="Our Vision" />
        </div>
      </section>

      {/* =========================
          MICROSOFT PARTNERSHIP (NEW)
          Example suggestion: 
          Place it after the third section for emphasis
      ========================== */}
      <section className="partner-section" data-aos="fade-up">
        <h2>Our Partnership</h2>
        <p>
          We’re proud to collaborate with{" "}
          <strong>Microsoft for Startups</strong> to accelerate innovation. This
          partnership provides us with cutting-edge resources and global
          support, enabling us to better serve safety-critical industries with
          advanced AI solutions.
        </p>
        <div className="partner-image">
          <img
            src="about_images/ms_partnership.webp"
            alt="Microsoft for Startups"
          />
        </div>
      </section>

      {/*FOOTER*/}
      <Footer />
    </main>
  );
}

export default AboutUs;
